// @ts-strict-ignore
import type { QueryHookOptions } from "@apollo/client";
import { gql, useLazyQuery, useQuery } from "@apollo/client";

const IdentifyTraits_Shared_Query = gql`
  query IdentifyTraits_Shared_Query {
    currentPractitioner {
      id
      isStoreOwner
      hasAcceptedLabsBaa
      hasSentFirstTpWithLabs
      hasSentSecondTpWithLabs
      hasSentFourthTpWithLabs
      hasSentSixthTpWithLabs
      practitionerType {
        id
        description
      }
    }
    currentStore {
      id
      marginType
      patientPromotionOptInStatus
      onboarding {
        id
        wholesaleIntention
        rxIntention
      }
      globalPatientPromotion {
        id
        optIn
      }
    }
    currentRole {
      anyCredentialApproved
      type
    }
    currentUser {
      id
      createdAt
      firstName
    }
    viewer {
      countryIso
      patientPromotionCutOffDate
    }
  }
`;

interface IdentifyTraitsQueryData {
  currentUser: {
    id: string;
    createdAt: string;
    firstName: string;
  };
  viewer: {
    countryIso: string;
    patientPromotionCutOffDate: number;
  };
  currentRole: {
    anyCredentialApproved: boolean;
    type;
  };
  currentStore: {
    patientPromotionOptInStatus: boolean;
    marginType: string;
    onboarding: {
      wholesaleIntention: boolean;
      rxIntention: boolean;
    };
    globalPatientPromotion: {
      optIn: boolean;
    };
  };
  currentPractitioner: {
    isStoreOwner: boolean;
    hasAcceptedLabsBaa: boolean;
    hasSentFirstTpWithLabs: boolean;
    hasSentSecondTpWithLabs: boolean;
    hasSentFourthTpWithLabs: boolean;
    hasSentSixthTpWithLabs: boolean;
    practitionerType: {
      description: string;
    };
  };
}

const useIdentifyTraitsQuery = (options?: QueryHookOptions<IdentifyTraitsQueryData>) => {
  return useQuery<IdentifyTraitsQueryData>(IdentifyTraits_Shared_Query, options);
};

const useIdentifyTraitsLazyQuery = (options?: QueryHookOptions<IdentifyTraitsQueryData>) => {
  return useLazyQuery<IdentifyTraitsQueryData>(IdentifyTraits_Shared_Query, options);
};

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export {
  useIdentifyTraitsQuery,
  useIdentifyTraitsLazyQuery,
  IdentifyTraits_Shared_Query,
  type IdentifyTraitsQueryData,
};
